import { render, staticRenderFns } from "./questionnaire.vue?vue&type=template&id=47f41808&scoped=true"
import script from "./questionnaire.vue?vue&type=script&setup=true&lang=js"
export * from "./questionnaire.vue?vue&type=script&setup=true&lang=js"
import style0 from "./questionnaire.vue?vue&type=style&index=0&id=47f41808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f41808",
  null
  
)

export default component.exports